<div class="modal-dialog modal-dialog-centered modal-md">
  <div class="modal-content">
    <div class="modal-header pb-2">
      <h5 class="modal-title" i18n>Detalhes do usuário</h5>
      <button type="button" (click)="onClose()"
        class="btn btn-fade-secondary btn-icon-block" data-dismiss="modal"
        aria-label="Close">
        <i class="material-icons">close</i>
      </button>
    </div>

    <div class="modal-body">
      <div class="row">
        <div class="col-md-2">
          <app-avatar
            [user]="initialState?.user"
            class="avatar-userGroup-list"></app-avatar>
        </div>
        <div class="col-md-10">
          <p class="mb-0 mt-2"><strong>{{ initialState?.user?.name
              }}</strong></p>
          <p class="mb-0">{{ initialState?.user?.email }}</p>
          <hr>
          <p class="text-secondary" i18n>Permissões</p>
          <div
            *ngFor="let permission of initialState?.user?.UserAdminPermissions"
            class="badge badge-fade-primary mr-1">
            <span>{{permissionI18n[permission?.AdminPermission?.name]}}</span>
          </div>
          <hr>
          <div
            *ngIf="initialState?.user?.superUser"
            class="badge badge-primary mr-1">
            <span><strong>Super usuário</strong></span>
          </div>
          <div
            *ngIf="initialState?.user?.adminManagerUser"
            class="badge badge-primary mr-1">
            <span><strong>Gestor Administrativo</strong></span>
          </div>
          <div
            *ngIf="initialState?.user?.adminUser"
            class="badge badge-primary mr-1">
            <span><strong>Usuário Administrativo</strong></span>
          </div>
        </div>
      </div>
    </div>

    <div class="loading-page" *ngIf="loading">
      <div class="loading-spinner">
        <div class="bounce1"></div>
        <div class="bounce2"></div>
        <div class="bounce3"></div>
      </div>
    </div>
  </div>
</div>
